import { GetAllModules, GetAllSubModuleSecurityPermissionsByRoleIdAndSubModuleSecurityKeyParentId, GetAllSubModulesByModuleId, GetRoleListByClientIdAndClientSecret } from "../ApiEndPoints";
import { axiosGet, axiosGetDetails, axiosGetMultiParams } from "../AxiosRequests";


export default class ModulePermissionServices {

    async getRoleListByClientIdAndClientSecret(request) {
        return axiosGetDetails(GetRoleListByClientIdAndClientSecret, request);
    }
    async getAllModules(request) {
        return axiosGet(GetAllModules, request);
    }
    async getAllSubModulesByModuleId(request) {
        return axiosGet(GetAllSubModulesByModuleId, request);
    }
    async getAllSubModuleSecurityPermissionsByRoleIdAndSubModuleSecurityKeyParentId(request) {
          return axiosGetMultiParams(GetAllSubModuleSecurityPermissionsByRoleIdAndSubModuleSecurityKeyParentId, request);
    }
}